import React from 'react'
import GridExampleVerticalAlignment from './GridExampleVerticalAlignment'

function FunnyKulius() {
  return (
    <div>
        <GridExampleVerticalAlignment/>
    </div>
  )
}

export default FunnyKulius